import React from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { useAuth } from '../Contexts/AuthContext'
import LogoVermelho from '../assets/LogoVermelho.svg'

export default function AdminMenu({ className = '' }) {
  const { logout, getUser, toggleContext, userRoles } = useAuth();
  const history = useHistory()
  const [open, setOpen] = React.useState(false)
  function handleLogout(){
    logout();
  }

  React.useEffect(() => {
    const listener = history.listen(() => {
      setOpen(false)
    })

    return () => {
      listener()
    }
  }, [history])

  React.useEffect(() => {
    if (open) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      document.body.classList.add('no-scroll')
      return
    }

    document.body.classList.remove('no-scroll')
  }, [open])

  function toggleHamburger() {
    setOpen(!open)
  }

  return (
    <header className={`new-header-admin ${className}`}>
      <div className="admin-container">
        <div className="admin-hello-message">
          <NavLink to="/area-admin">
            <img
              src={LogoVermelho}
              className="logo-vermelho"
              alt="Santa Rosa Futsal"
              width="46"
              height="51"
            />
          </NavLink>
          {getUser() && (
            <h1>
              Olá <strong>{getUser()}!</strong>
            </h1>
          )}
        </div>

        <button
          className={`hamburger hamburger--spring outline-0 z-index-999 hamburger-admin ${
            open ? 'hamburger-black is-active' : ''
          }`}
          type="button"
          onClick={toggleHamburger}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>

        <div
          className="menu-side socio-menu-side"
          style={{ right: open ? '0vw' : '150vw' }}
        >
          <div className="menu-side-wrapper">
            <nav className="menu-side-content">
              <NavLink
                className="nav-link nav-item-side color-black"
                to="/area-admin/Admins"
              >
                Admin
              </NavLink>
              <NavLink
                className="nav-link nav-item-side color-black"
                to="/area-admin/socios"
              >
                Sócios
              </NavLink>
              <NavLink
                className="nav-link nav-item-side color-black"
                to="/area-admin/diretorias"
              >
                Diretoria
              </NavLink>
              <NavLink
                className="nav-link nav-item-side color-black"
                to="/area-admin/competicoes"
              >
                Competições
              </NavLink>
              <NavLink
                className="nav-link nav-item-side color-black"
                to="/area-admin/elencos"
              >
                Elenco
              </NavLink>
              <NavLink
                className="nav-link nav-item-side color-black"
                to="/area-admin/jogos"
              >
                Jogos
              </NavLink>
              <NavLink
                className="nav-link nav-item-side color-black"
                to="/area-admin/tabela-classificacao"
              >
                Tabela
              </NavLink>
              <NavLink
                className="nav-link nav-item-side color-black"
                to="/area-admin/patrocinadores"
              >
                Patrocinadores
              </NavLink>
              <NavLink
                className="nav-link nav-item-side color-black"
                to="/area-admin/manutencao-planos"
              >
                Planos
              </NavLink>
              <NavLink
                className="nav-link nav-item-side color-black"
                to="/area-admin/noticias"
              >
                Notícias
              </NavLink>
              <NavLink
                className="nav-link nav-item-side color-black"
                to="/area-admin/financeiro"
              >
                Financeiro
              </NavLink>
              {userRoles?.isSocio && (
              <button
                className='nav-link nav-item-side outline-0 dropdown-item custom-dropdown admin-socio'
                onClick={toggleContext}
              >
                {/* <Icon icon="fas fa-people-arrows" color="#d69947" /> */}
                Área Sócio
              </button>
            )}{' '}
              <button
                className='nav-link nav-item-side outline-0 dropdown-item custom-dropdown admin-sair'
                onClick={() => {
                  document.body.classList.remove('no-scroll')
                  handleLogout()
                }}
              >
               Sair
              </button>
            </nav>
          </div>
        </div>
      </div>
    </header>
  )
}
